import React from 'react';
import styled from 'styled-components';

import { useCollection, useDocument } from '@nandorojo/swr-firestore';
import DdayItem from './DdayItem';
import { SettingCollectionPath } from '@typings/collections.enum';
import { IhomepageSetting } from '@typings/setting/homepageSetting.interface';
import type {
  DdayDesignType,
  ImageLayoutDirection,
  ImageTextAlign,
} from './DdayItem';

const ListWrapper = styled.div`
  border-radius: var(--cardBorderRadius);
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  &::-webkit-scrollbar {
    display: none;
  }
`;

const EmptyPage = styled.div`
  width: 100%;
  color: var(--subTextColor);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
`;

type Props = {
  noImage?: boolean;
};

function DdayWidget({ noImage = false }: Props) {
  const { data } = useCollection<IddayWidget>('ddayWidget', {
    orderBy: ['order', 'asc'],
    listen: true,
  });

  const { data: homeSet } = useDocument<IhomepageSetting>(
    `${SettingCollectionPath.HOMEPAGE}`,
    { listen: true },
  );

  // 홈페이지 설정에서 디자인 타입 가져오기
  const designType: DdayDesignType =
    homeSet?.ddayWidget?.designType === 'image' ? 'image' : 'text';

  if (data?.length === 0)
    return (
      <EmptyPage>
        <p>등록된 위젯이 없습니다.</p>
      </EmptyPage>
    );

  return (
    <ListWrapper>
      {data &&
        data.map((item) => {
          return (
            <DdayItem
              noImage={noImage}
              key={item.id}
              data={item}
              designType={designType}
              imageTextAlign={
                homeSet?.ddayWidget?.imageTextAlign as ImageTextAlign
              }
              imageLayoutDirection={
                homeSet?.ddayWidget
                  ?.imageLayoutDirection as ImageLayoutDirection
              }
            />
          );
        })}
    </ListWrapper>
  );
}

export default DdayWidget;
